import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[fileSystemRegex]',
  standalone: false,
})
export class FileSystemDirective {
  // Windows invalid filename characters: \\ / : * ? " < > |
  private readonly invalidChars = /[\\/:*?"<>|]/g;

  constructor(private readonly ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    if (value == null) {
      return;
    }

    let sanitized = value;

    // Remove invalid characters (keep letters, numbers, underscore, dash, dot)
    sanitized = sanitized.replace(this.invalidChars, '');

    // Allow only a single dot (preserve first occurrence for extension, remove the rest)
    const firstDotIndex = sanitized.indexOf('.');
    if (firstDotIndex !== -1) {
      const before = sanitized.slice(0, firstDotIndex + 1);
      const after = sanitized.slice(firstDotIndex + 1).replace(/\./g, '');
      sanitized = before + after;
    }

    // Disallow leading dot(s) or spaces (no hidden or trailing-dot names)
    sanitized = sanitized.replace(/^[\. ]+/, '');

    // Prevent trailing spaces
    sanitized = sanitized.replace(/ +$/, '');

    // Only update if changed to avoid cursor jumps from redundant sets
    const control = this.ngControl.control;
    if (control && control.value !== sanitized) {
      control.setValue(sanitized, { emitEvent: false });
    }
  }
}
